"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobx = require("mobx");
var _reactIntl = require("react-intl");
var _mobxReact = require("mobx-react");
var _ProgressContainer = _interopRequireDefault(require("../../progress/container/ProgressContainer"));
var _ErrorContainer = _interopRequireDefault(require("../../error/container/ErrorContainer"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _Events = _interopRequireDefault(require("../../../../constants/Events"));
var _ToastContainer = _interopRequireDefault(require("../../toast/container/ToastContainer"));
var _ComponentRegistry = _interopRequireDefault(require("../../../../util/ComponentRegistry"));
var _propTypes = require("prop-types");
var _dec, _class, _class2, _descriptor, _AppContainer;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
const consumeEvent = e => {
  e.stopPropagation();
  e.preventDefault();
};
let AppContainer = exports.AppContainer = (_dec = _mobx.action.bound, (0, _mobxReact.observer)(_class = (_class2 = (_AppContainer = class AppContainer extends _react.default.Component {
  constructor(props, context) {
    super(props, context);
    _initializerDefineProperty(this, "hideMainDiv", _descriptor, this);
    this._appStore = _ServiceRegistry.default.getService("AppStore");
    this._appStore.setIntl(props.intl);
  }
  componentDidMount() {
    _ServiceRegistry.default.getService("EventsService").sendEvent(_Events.default.APP_RENDERING_START);
    this._appStore.appRenderingStartedPromise.resolve();
    // Prevent drag-and-drop from loading file
    window.addEventListener("dragover", consumeEvent, false);
    window.addEventListener("drop", consumeEvent, false);
  }
  setHideMainDiv(value) {
    this.hideMainDiv = value;
  }
  getProps() {
    const config = this._appStore.getConfig();
    if (config.isViewSDKPublic) {
      return _objectSpread({
        setHideMainDiv: this.setHideMainDiv.bind(this),
        hideMainDiv: this.hideMainDiv
      }, this.props);
    }
    return this.props;
  }
  getToastContainer() {
    return /*#__PURE__*/_react.default.createElement(_ToastContainer.default, null);
  }
  render() {
    if (!this._oneTimeMessage) {
      _ServiceRegistry.default.getService("LoggingService").logExternal("App attached to DOM.");
      this._oneTimeMessage = true;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._appStore.showLoader && !this._appStore.getConfig().showSimpleLoader && /*#__PURE__*/_react.default.createElement(_ProgressContainer.default, {
      progressText: this._appStore.progressText
    }), this._appStore.showToast && this.getToastContainer(), this._appStore.appError && /*#__PURE__*/_react.default.createElement(_ErrorContainer.default, _extends({
      intl: this.props.intl
    }, this.props)), this._appStore.isHidingBranding && _ComponentRegistry.default.getComponent("HidingBrandingContainer"), _ComponentRegistry.default.getComponent("App", this.getProps()));
  }
}, _AppContainer.propTypes = {
  intl: _propTypes.PropTypes.object.isRequired
}, _AppContainer), (_applyDecoratedDescriptor(_class2.prototype, "setHideMainDiv", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "setHideMainDiv"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "hideMainDiv", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
const injectedAppContainer = (0, _reactIntl.injectIntl)(AppContainer);

// for inheritance
var _default = exports.default = injectedAppContainer;